import { Form, FormButton, FormItem, FormSubmitHandler, TextInput } from "@sis/react-library"
import { ExampleDto } from "./FormSamplesFormOnlyFieldsPage";

/////////////////////////////////////////////////////////////////////////////////////////////
// Some fields are only used on the form, in this example the confirm password is only used
// in this form component, but not needed anywhere else in the application. 
// So the confirm password field is:
// - defined only in the interface for this form.
// - exluded on submit. (Done on the FormItem component for confirm password).
/////////////////////////////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////////////////////////////
// Interface for the form (see basic usage example for more information).
/////////////////////////////////////////////////////////////////////////////////////////////
interface T extends ExampleDto {
    confirmPassword: string; // The additional confirm password (used in the form only) is defined here.
}

interface FormSamplesFormOnlyFieldsFormProps {
    onSubmit: FormSubmitHandler<ExampleDto>;
    submitting: boolean;
}

export const FormSamplesFormOnlyFieldsForm = ({
    onSubmit, submitting
}: FormSamplesFormOnlyFieldsFormProps) => {

    const formName = 'FormFormOnlyFields';

    return (
        <Form<T>
            name={formName}
            onSubmit={onSubmit}
            submitting={submitting}
            beforeLeaveText='You have made changes, are you sure you want to leave ?'
        >
            <FormItem<T>
                formField="firstName"
                label="First Name"
                element={<TextInput maxLength={20} />}
            />
            <FormItem<T>
                formField="lastName"
                label="Last Name"
                element={<TextInput maxLength={20} />}
            />
            <FormItem<T>
                formField="password"
                label="Please enter a password!"
                rules={[{ type: "required", message: "Please enter a password!" }]}
                element={<TextInput type="password" maxLength={20} />}
            />
            <FormItem<T>
                formField="confirmPassword"
                label="Confirm Password"
                excludeOnSubmit  // This excludes this field when submitting (as it's not needed for posting to a backend)
                rules={[
                    { type: "compareEqual", field: "password", message: "Passwords don't match!" },
                    { type: "required", message: "Please confirm your password!" }
                ]}
                element={<TextInput type="password" maxLength={50} />}
            />
            <FormButton
                formButtonText='Submit'
                submitButton
                fullWidth
                sx={{ mt: 3, mb: 2 }}
            />
        </Form>
    )
}
